import { SentryApiClient } from '_generated/api';
import { UserType } from 'Users/userTypes';

/**
 * Determines the appropriate logo to display based on user context
 * This replaces hardcoded company logic with dynamic company-based selection
 */
export const getCompanyLogo = (
  user: SentryApiClient.UserDTO | null
): string => {
  // 1. Check for special domains (like Sensotraq) based on URL
  const isSensotraq = window.location.href.includes('sensotraq');
  if (isSensotraq) {
    return '/sensotraqWhite.png';
  }

  // 2. For authenticated users, use company-based logic
  if (user) {
    // Admins always use Sentry logo
    if (user.userTypeId === UserType.Administrator) {
      return '/sentry-logo.png';
    }

    // If user belongs to companies, return the company logo API endpoint
    if (user.companies && user.companies.length > 0) {
      const firstCompanyId = user.companies[0];
      return `/api/companies/${firstCompanyId}/logo`;
    }
  }

  // 3. Default to Sentry logo
  return '/sentry-logo.png';
};

/**
 * Get company logo for authenticated contexts where we can make API calls
 * Returns the first company ID if user has companies, null otherwise
 */
export const getCompanyLogoId = (
  user: SentryApiClient.UserDTO | null
): number | null => {
  if (!user || user.userTypeId === UserType.Administrator) {
    return null; // Use static Sentry logo
  }
  if (user) {
    if (user.companies && user.companies.length > 0) {
      return user.companies[0]; // Return first company ID
    }
  }

  return null; // Use static Sentry logo
};
